import { PLURAL } from "neetocommons/constants";
import { Flash, Plus } from "neetoicons";
import { Button, Typography } from "neetoui";
import { useTranslation } from "react-i18next";

import { PANEL_TYPES } from "../../constants";

const TitleBar = ({
  setVisiblePanel,
  isLoading,
  showElementsFillButton,
  isAddingAllElements,
  addAllElements,
  isAddingNewElement,
  addNewElement,
  addNewElementLabel,
}) => {
  const { t } = useTranslation();

  const handleAddNewElementClick = () => {
    if (typeof addNewElement === "function") addNewElement();
    else setVisiblePanel(PANEL_TYPES.ELEMENTS);
  };

  return (
    <div
      className="flex items-center justify-between p-6 pb-1"
      data-testid="selected-elements-title"
    >
      <Typography
        data-testid="elements-title"
        lineHeight="normal"
        style="h3"
        weight="semibold"
      >
        {t("neetoMolecules.builderSidebar.element", PLURAL)}
      </Typography>
      <div className="flex items-center justify-between gap-x-2">
        <Button
          data-testid="add-element-button"
          disabled={isLoading}
          icon={Plus}
          iconPosition="left"
          loading={isAddingNewElement}
          size="small"
          style="link"
          label={
            addNewElementLabel ||
            t("neetoMolecules.builderSidebar.addNewElement")
          }
          onClick={handleAddNewElementClick}
        />
        {showElementsFillButton && (
          <Button
            data-testid="add-all-elements-button"
            disabled={isAddingAllElements}
            icon={Flash}
            loading={isAddingAllElements}
            size="small"
            style="secondary"
            tooltipProps={{
              content: t("neetoMolecules.builderSidebar.addAllElements"),
              touch: ["hold", 500],
            }}
            onClick={addAllElements}
          />
        )}
      </div>
    </div>
  );
};

export default TitleBar;
